import { render, staticRenderFns } from "./rmTaak.vue?vue&type=template&id=4a70c1ed"
import script from "./rmTaak.vue?vue&type=script&lang=js"
export * from "./rmTaak.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports